import * as React from "react"
import {
  Create,
} from "react-admin"
import UserForm from "./UserForm"

const UserTitle = () => {
  return <span>{'帳號'}</span>;
};

const UserCreate = () => (
  <Create 
    title={<UserTitle/>}
  >
    <UserForm 
      formType="create" 
    />
  </Create>
)

export default UserCreate